import { BaseModel } from '../../_base/crud';

export class PatientModel extends BaseModel {
  id: number;
  patient_id: string;
  patient_no: number;
  facility_id: any;
  facility_name: string;
  last_name: string;
  first_name: string;
  middle_name: string;
  last_name2: string;
  dob: string;
  address_1: string;
  address_2: string;
  city: string;
  state: string;
  zip: string;
  location_id: number;
  home_phone: string;
  cell_phone: string;
  primary_language: string;
  email: string;
  note: string;
  is_active: boolean;
  office_id: number;
  patient_class: string;
  hold_flag: boolean;
  hold_note: string;
  hold_date: string;
  in_hospital: boolean;
  in_hospital_date: string;
  processed: boolean;
  diagnosis: string;
  icd: string;
  other_allergies: string;
  other_medications: string;
  gender: string;
  last_modified_user: string;
  tags: string;
  affiliation_groups: string;
  fax: string;
  urbanization: any;
  avatar: string;
  pre_signed_url: any;
  plus_code: any;
  latitude: any;
  longitude: any;
  geolocation_address;
  species: any;
  office_number: any;
  extension: any;
  deceased_date: any;
  clear() {
    this.urbanization = null;
    this.fax = '';
    this.id = 0;
    this.patient_id = '';
    this.patient_no = 0;
    this.facility_id = 0;
    this.facility_name = '';
    this.first_name = '';
    this.middle_name = '';
    this.last_name2 = '';
    this.dob = '';
    this.address_1 = '';
    this.address_2 = '';
    this.city = '';
    this.state = '';
    this.zip = '';
    this.location_id = 0;
    this.home_phone = '';
    this.cell_phone = '';
    this.primary_language = '';
    this.email = '';
    this.note = '';
    this.is_active = true;
    this.office_id = 0;
    this.patient_class = '';
    this.hold_flag = false;
    this.hold_note = '';
    this.hold_date = '';
    this.in_hospital = false;
    this.in_hospital_date = '';
    this.processed = true;
    this.diagnosis = '';
    this.icd = '';
    this.other_allergies = '';
    this.other_medications = '';
    this.gender = '';
    this.last_modified_user = '';
    this.office_number = null;
    this.extension = null;
    this.species = null;
    this.deceased_date = '';
  }
}
